export interface CloudAccount {
  id: string;
  name: string;
  externalId: string;
}

export class CloudAccountInput {
  cloudAccount!: string;
  environment?: string;
}

export class ClusterInput {
  kubernetesClusters!: string[];
}

export interface ClusterAccount {
  id: string;
  name: string;
  externalId: string;
  cloudAccount: ClusterCloudAccount[];
}

export interface ClusterCloudAccount {
  id: string;
  name: string;
  externalId: string;
  cloudProvider: string;
}
